// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_packages.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { RfiPackage, RfiPackageItem, RfiPackageVersion, RfiSubmission, RfiSubmissionReceipt } from "../../datagateway/v1/rfi_packages_pb";
/**
 * @generated from message mono.projectdata.v1.ListRfiPackagesRequest
 */ export class ListRfiPackagesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiPackagesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiPackagesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiPackagesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiPackagesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiPackagesRequest, "runtime", proto3);
_define_property(ListRfiPackagesRequest, "typeName", "mono.projectdata.v1.ListRfiPackagesRequest");
_define_property(ListRfiPackagesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiPackagesResponse
 */ export class ListRfiPackagesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiPackagesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiPackagesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiPackagesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiPackagesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiPackage packages = 1;
   */ _define_property(this, "packages", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiPackagesResponse, "runtime", proto3);
_define_property(ListRfiPackagesResponse, "typeName", "mono.projectdata.v1.ListRfiPackagesResponse");
_define_property(ListRfiPackagesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "packages",
            kind: "message",
            T: RfiPackage,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiPackageRequest
 */ export class CreateRfiPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string request_id = 2;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * WRT-16: with a response document the package pins it at once.
   * "docx" | "pdf"; "" = rfiPreferredPackageFormat(submission_format).
   *
   * @generated from field: string export_format = 10;
   */ _define_property(this, "exportFormat", ""), /**
   * the response-document version to pin; "" = current, after forcesave
   *
   * @generated from field: string document_version_id = 11;
   */ _define_property(this, "documentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiPackageRequest, "runtime", proto3);
_define_property(CreateRfiPackageRequest, "typeName", "mono.projectdata.v1.CreateRfiPackageRequest");
_define_property(CreateRfiPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "export_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiPackageResponse
 */ export class CreateRfiPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackage package = 1;
   */ _define_property(this, "package", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiPackageResponse, "runtime", proto3);
_define_property(CreateRfiPackageResponse, "typeName", "mono.projectdata.v1.CreateRfiPackageResponse");
_define_property(CreateRfiPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "package",
            kind: "message",
            T: RfiPackage
        }
    ]));
/**
 * All IDs are required, including the exact historical version. No latest fallback.
 *
 * @generated from message mono.projectdata.v1.SelectRfiPackageVersionRequest
 */ export class SelectRfiPackageVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectRfiPackageVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectRfiPackageVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectRfiPackageVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectRfiPackageVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string section_id = 4;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string document_version_id = 5;
   */ _define_property(this, "documentVersionId", ""), /**
   * WRT-16: with section_id "" on an RFI with a response document, pins the
   * response document (document_version_id "" = current). "docx" | "pdf";
   * "" = rfiPreferredPackageFormat(submission_format).
   *
   * @generated from field: string export_format = 10;
   */ _define_property(this, "exportFormat", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectRfiPackageVersionRequest, "runtime", proto3);
_define_property(SelectRfiPackageVersionRequest, "typeName", "mono.projectdata.v1.SelectRfiPackageVersionRequest");
_define_property(SelectRfiPackageVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "export_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SelectRfiPackageVersionResponse
 */ export class SelectRfiPackageVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectRfiPackageVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectRfiPackageVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectRfiPackageVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectRfiPackageVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectRfiPackageVersionResponse, "runtime", proto3);
_define_property(SelectRfiPackageVersionResponse, "typeName", "mono.projectdata.v1.SelectRfiPackageVersionResponse");
_define_property(SelectRfiPackageVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RfiPackageItem
        }
    ]));
/**
 * Produces a DOCX copy of the selected immutable bytes, preserving provenance.
 *
 * @generated from message mono.projectdata.v1.GenerateRfiPackageArtifactRequest
 */ export class GenerateRfiPackageArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateRfiPackageArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateRfiPackageArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateRfiPackageArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateRfiPackageArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string selection_item_id = 4;
   */ _define_property(this, "selectionItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateRfiPackageArtifactRequest, "runtime", proto3);
_define_property(GenerateRfiPackageArtifactRequest, "typeName", "mono.projectdata.v1.GenerateRfiPackageArtifactRequest");
_define_property(GenerateRfiPackageArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "selection_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GenerateRfiPackageArtifactResponse
 */ export class GenerateRfiPackageArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateRfiPackageArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateRfiPackageArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateRfiPackageArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateRfiPackageArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateRfiPackageArtifactResponse, "runtime", proto3);
_define_property(GenerateRfiPackageArtifactResponse, "typeName", "mono.projectdata.v1.GenerateRfiPackageArtifactResponse");
_define_property(GenerateRfiPackageArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RfiPackageItem
        }
    ]));
/**
 * Upload first via Tesoro CreateUploadSession + PUT + CompleteUpload, project_id
 * = RFI zou_project_id, auto_process=false. The uploader attaches the returned ID.
 *
 * @generated from message mono.projectdata.v1.AttachRfiPackageArtifactRequest
 */ export class AttachRfiPackageArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new AttachRfiPackageArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachRfiPackageArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachRfiPackageArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachRfiPackageArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachRfiPackageArtifactRequest, "runtime", proto3);
_define_property(AttachRfiPackageArtifactRequest, "typeName", "mono.projectdata.v1.AttachRfiPackageArtifactRequest");
_define_property(AttachRfiPackageArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AttachRfiPackageArtifactResponse
 */ export class AttachRfiPackageArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new AttachRfiPackageArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachRfiPackageArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachRfiPackageArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachRfiPackageArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachRfiPackageArtifactResponse, "runtime", proto3);
_define_property(AttachRfiPackageArtifactResponse, "typeName", "mono.projectdata.v1.AttachRfiPackageArtifactResponse");
_define_property(AttachRfiPackageArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RfiPackageItem
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DownloadRfiPackageArtifactRequest
 */ export class DownloadRfiPackageArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DownloadRfiPackageArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadRfiPackageArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadRfiPackageArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadRfiPackageArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string item_id = 3;
   */ _define_property(this, "itemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadRfiPackageArtifactRequest, "runtime", proto3);
_define_property(DownloadRfiPackageArtifactRequest, "typeName", "mono.projectdata.v1.DownloadRfiPackageArtifactRequest");
_define_property(DownloadRfiPackageArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DownloadRfiPackageArtifactResponse
 */ export class DownloadRfiPackageArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DownloadRfiPackageArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadRfiPackageArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadRfiPackageArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadRfiPackageArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string url = 1;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadRfiPackageArtifactResponse, "runtime", proto3);
_define_property(DownloadRfiPackageArtifactResponse, "typeName", "mono.projectdata.v1.DownloadRfiPackageArtifactResponse");
_define_property(DownloadRfiPackageArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureRfiPackageVersionRequest
 */ export class CaptureRfiPackageVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CaptureRfiPackageVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureRfiPackageVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureRfiPackageVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureRfiPackageVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: repeated string item_ids = 4;
   */ _define_property(this, "itemIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureRfiPackageVersionRequest, "runtime", proto3);
_define_property(CaptureRfiPackageVersionRequest, "typeName", "mono.projectdata.v1.CaptureRfiPackageVersionRequest");
_define_property(CaptureRfiPackageVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureRfiPackageVersionResponse
 */ export class CaptureRfiPackageVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CaptureRfiPackageVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureRfiPackageVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureRfiPackageVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureRfiPackageVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureRfiPackageVersionResponse, "runtime", proto3);
_define_property(CaptureRfiPackageVersionResponse, "typeName", "mono.projectdata.v1.CaptureRfiPackageVersionResponse");
_define_property(CaptureRfiPackageVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiPackageVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiPackageVersionRequest
 */ export class GetRfiPackageVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiPackageVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiPackageVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiPackageVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiPackageVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiPackageVersionRequest, "runtime", proto3);
_define_property(GetRfiPackageVersionRequest, "typeName", "mono.projectdata.v1.GetRfiPackageVersionRequest");
_define_property(GetRfiPackageVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiPackageVersionResponse
 */ export class GetRfiPackageVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiPackageVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiPackageVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiPackageVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiPackageVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiPackageVersionResponse, "runtime", proto3);
_define_property(GetRfiPackageVersionResponse, "typeName", "mono.projectdata.v1.GetRfiPackageVersionResponse");
_define_property(GetRfiPackageVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiPackageVersion
        }
    ]));
/**
 * Records a human's already completed act; does not send anything externally.
 * id, recorded_by/at and response scope on the nested submission are server owned.
 *
 * @generated from message mono.projectdata.v1.RecordRfiSubmissionRequest
 */ export class RecordRfiSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiSubmission submission = 2;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSubmissionRequest, "runtime", proto3);
_define_property(RecordRfiSubmissionRequest, "typeName", "mono.projectdata.v1.RecordRfiSubmissionRequest");
_define_property(RecordRfiSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission",
            kind: "message",
            T: RfiSubmission
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordRfiSubmissionResponse
 */ export class RecordRfiSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSubmission submission = 1;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSubmissionResponse, "runtime", proto3);
_define_property(RecordRfiSubmissionResponse, "typeName", "mono.projectdata.v1.RecordRfiSubmissionResponse");
_define_property(RecordRfiSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: RfiSubmission
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSubmissionsRequest
 */ export class ListRfiSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionsRequest, "runtime", proto3);
_define_property(ListRfiSubmissionsRequest, "typeName", "mono.projectdata.v1.ListRfiSubmissionsRequest");
_define_property(ListRfiSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSubmissionsResponse
 */ export class ListRfiSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSubmission submissions = 1;
   */ _define_property(this, "submissions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionsResponse, "runtime", proto3);
_define_property(ListRfiSubmissionsResponse, "typeName", "mono.projectdata.v1.ListRfiSubmissionsResponse");
_define_property(ListRfiSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: RfiSubmission,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AppendRfiSubmissionReceiptRequest
 */ export class AppendRfiSubmissionReceiptRequest extends Message {
    static fromBinary(bytes, options) {
        return new AppendRfiSubmissionReceiptRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendRfiSubmissionReceiptRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendRfiSubmissionReceiptRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendRfiSubmissionReceiptRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiSubmissionReceipt receipt = 3;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendRfiSubmissionReceiptRequest, "runtime", proto3);
_define_property(AppendRfiSubmissionReceiptRequest, "typeName", "mono.projectdata.v1.AppendRfiSubmissionReceiptRequest");
_define_property(AppendRfiSubmissionReceiptRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "receipt",
            kind: "message",
            T: RfiSubmissionReceipt
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AppendRfiSubmissionReceiptResponse
 */ export class AppendRfiSubmissionReceiptResponse extends Message {
    static fromBinary(bytes, options) {
        return new AppendRfiSubmissionReceiptResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendRfiSubmissionReceiptResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendRfiSubmissionReceiptResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendRfiSubmissionReceiptResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSubmissionReceipt receipt = 1;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendRfiSubmissionReceiptResponse, "runtime", proto3);
_define_property(AppendRfiSubmissionReceiptResponse, "typeName", "mono.projectdata.v1.AppendRfiSubmissionReceiptResponse");
_define_property(AppendRfiSubmissionReceiptResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipt",
            kind: "message",
            T: RfiSubmissionReceipt
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSubmissionReceiptsRequest
 */ export class ListRfiSubmissionReceiptsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionReceiptsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionReceiptsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionReceiptsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionReceiptsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionReceiptsRequest, "runtime", proto3);
_define_property(ListRfiSubmissionReceiptsRequest, "typeName", "mono.projectdata.v1.ListRfiSubmissionReceiptsRequest");
_define_property(ListRfiSubmissionReceiptsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSubmissionReceiptsResponse
 */ export class ListRfiSubmissionReceiptsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionReceiptsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionReceiptsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionReceiptsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionReceiptsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSubmissionReceipt receipts = 1;
   */ _define_property(this, "receipts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionReceiptsResponse, "runtime", proto3);
_define_property(ListRfiSubmissionReceiptsResponse, "typeName", "mono.projectdata.v1.ListRfiSubmissionReceiptsResponse");
_define_property(ListRfiSubmissionReceiptsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipts",
            kind: "message",
            T: RfiSubmissionReceipt,
            repeated: true
        }
    ]));
